module.exports = __webpack_public_path__ + "img/sy5.a724d949.png";